module.exports = __webpack_public_path__ + "media/books/CustomerAvatar-220f5dc8.png";